import { Component } from '@angular/core';
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'app works!';
  footerDate = this.GetCurrentYear();

  GetCurrentYear() {
    var date = new Date();
    return date.getUTCFullYear();
  }
}

$(document).ready(function () {
  $('.navbar.mobile .navbar-nav>li>a').on('click', function () {
    $('.navbar.mobile .navbar-collapse').collapse('hide');
  });
});


// WEBPACK FOOTER //
// ./src/app/app.component.ts